export const dentalOfficeLeftFields = [
  {
    name: 'dentistCount',
    label: 'Nombre de praticiens exerçants :',
    placeholder: 'Ex : 3',
    type: 'number',
    required: true
  },
  {
    name: 'collabDentistCount',
    label: 'Nombre de praticiens collabs :',
    placeholder: 'Ex : 3',
    type: 'number',
    required: true
  },
  {
    name: 'chairsideAssistantCount',
    label: 'Nombre d’assistant(e)s fauteuil – travail à 4 mains :',
    placeholder: 'Ex : 3',
    type: 'number',
    required: true
  },
  {
    name: 'surfaceSqm',
    label: 'Surface du cabinet dentaire en m² :',
    placeholder: 'Ex : 29',
    end: 'm²',
    type: 'number',
    required: true
  },
  {
    name: 'managementSoftware',
    label: 'Nom du logiciel de gestion du cabinet :',
    type: 'autocomplete',
    placeholder: 'Ex : Vivadent',
    required: true
  }
];
